import { useDispatch, useSelector } from 'react-redux'
import { IRequest } from 'kyc-core/dist/Interfaces'
import { useState } from 'react'
import useStepFormHook from './useStepFormHook'
import { IStore } from '../interfaces/Store'
import { IStepPropsPeriodique } from '../interfaces/Step'
import kycCore from '../services/Kyc'
import { loadingActions } from '../store/slices/Loading'

const Step6FormHook = (props: IStepPropsPeriodique) => {
  const { form, onSubmit } = useStepFormHook(props)
  const { validation_terms_and_conditions } = useSelector(
    (stateReducer: IStore) => stateReducer.folderReducer.folder
  )

  const [modalOpen, setModalOpen] = useState(false)
  const dispatch = useDispatch()
  const { request, handleResponse } = kycCore
  const { handleJSONResponse } = handleResponse
  const signCertificate = async () => {
    const params: IRequest = {
      endpoint: 'api/signature',
      method: 'POST',
      queryParams: {
        currentStep: props.step.toString(),
        documentType: '9',
      },
    }
    const response = await request.request(params)
    return handleJSONResponse(response)
  }
  const onFormSubmit = async (data: Record<string, any>) => {
    try {
      dispatch(loadingActions.loading())
      await signCertificate()
      dispatch(loadingActions.loaded())
    } catch (e) {
      setModalOpen(true)
      dispatch(loadingActions.loaded())
      return
    }
    await onSubmit(data)
  }

  return {
    form,
    onFormSubmit,
    validation_terms_and_conditions,
    modalOpen,
    setModalOpen,
  }
}

export default Step6FormHook
